import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';

/**
 * Non-IMEI products (Airpods, Smartwatch, accessories): kis customer ko kab becha.
 */
export default function ProductSaleHistoryModal({ show, productId, productName, onClose }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!show || !productId) return;
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const res = await axios.get(`${config.API_URL}/products/${productId}/sale-history`);
        if (!cancelled) setData(res.data);
      } catch (err) {
        if (!cancelled) {
          setError(err.response?.data?.message || err.message || 'Failed to load sale history');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [show, productId]);

  if (!show || !productId) return null;

  const fmt = (n) => (n != null && !Number.isNaN(Number(n)) ? `₹${Number(n).toLocaleString('en-IN')}` : '—');
  const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('en-IN') : '—');

  return (
    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="bi bi-clock-history me-2"></i>
              Sale History — {productName || data?.productName || 'Product'}
            </h5>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>

          <div className="modal-body">
            {loading && (
              <div className="text-center py-4">
                <span className="spinner-border spinner-border-sm me-2"></span>
                Loading…
              </div>
            )}
            {error && <div className="alert alert-danger mb-0">{error}</div>}

            {!loading && !error && data && (
              <>
                <div className="row mb-3 g-2">
                  <div className="col-4">
                    <div className="card bg-success text-white text-center py-2">
                      <div className="fw-bold">{data.currentStock ?? 0}</div>
                      <small>In stock</small>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="card bg-primary text-white text-center py-2">
                      <div className="fw-bold">{data.totalUnitsSold ?? 0}</div>
                      <small>Units sold</small>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="card bg-info text-white text-center py-2">
                      <div className="fw-bold">{data.sales?.length ?? 0}</div>
                      <small>Sale records</small>
                    </div>
                  </div>
                </div>

                <p className="small text-muted">
                  Har sale alag row — 5 piece stock mein the thi to 5 alag customers yahan dikhenge (jab alag-alag
                  sale record ki hongi).
                </p>

                {(!data.sales || data.sales.length === 0) ? (
                  <div className="alert alert-info mb-0">
                    Abhi koi sale record nahi. Cart button se sale record karein — customer naam/phone save karein
                    taaki yahan dikhe.
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-sm table-hover">
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Date</th>
                          <th>Customer</th>
                          <th>Phone</th>
                          <th>Qty</th>
                          <th>Price</th>
                          <th>Type</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.sales.map((row, idx) => (
                          <tr key={row.id || `${row.source}-${idx}`}>
                            <td>{idx + 1}</td>
                            <td className="text-nowrap">{fmtDate(row.date)}</td>
                            <td>
                              <strong>{row.customerName || '—'}</strong>
                              {row.soldByName ? (
                                <div className="text-muted small">by {row.soldByName}</div>
                              ) : null}
                            </td>
                            <td className="text-nowrap">{row.customerPhone || '—'}</td>
                            <td>{row.quantity ?? 1}</td>
                            <td>{fmt(row.salePrice)}</td>
                            <td>
                              {row.isEmi ? (
                                <span className="badge bg-primary">EMI</span>
                              ) : (
                                <span className="badge bg-success">Cash</span>
                              )}
                            </td>
                            <td className="text-nowrap">
                              {row.customerId ? (
                                <Link
                                  to={`/customer/${row.customerId}`}
                                  className="btn btn-sm btn-outline-secondary py-0"
                                >
                                  Customer
                                </Link>
                              ) : null}
                              {row.emiId ? (
                                <>
                                  {' '}
                                  <Link
                                    to={`/emi/${encodeURIComponent(String(row.emiId))}`}
                                    className="btn btn-sm btn-outline-primary py-0"
                                  >
                                    EMI
                                  </Link>
                                </>
                              ) : null}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </>
            )}
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
